export const PROMO_CODES = {
  FSASTORE30: 'FSASTORE30',
  HSASTORE30: 'HSASTORE30',
  FSAHSA80: 'FSAHSA80'
}

export const UPSELL_PROMO_CODES = {
  CREAM: 'ESTRIOL51',
  MINOXIDIL: 'UPSELL51',
  DEEPSLEEP: 'DEEPSLEEP30'
}